App.prototype.checkSingleLevelVariationStatus = function (variations) {
    variations
        .filter(variation => variation.variationOptions.length === 1)
        .filter(
            variation =>
                (variation.is_active === 0 || (variation.is_active === null && main_product.is_active === 0)) ||
                (variation.is_out_of_stock === true || (variation.is_out_of_stock === null && main_product.is_out_of_stock === true))
        )
        .map((variation) => variation.variationOptions)
        .flat()
        .map(function (value) {
            $('[data-variation-id][value="'+value+'"]').prop('disabled', true);
        });
}
